import { sanitize } from '@/service/report/sanitize';

export function buildHtmlReport(html, $scope) {
  var outputHtml = [];

  var usingTags = {};

  if (html) {
    var arrayHtml = sanitize(html).split('\n');

    angular.forEach(arrayHtml, function (line) {
      if (line) {
        // data-field-nameのタグを探す
        var matches = line.match(/data-field-name=[^>]*>/gi);

        if (matches) {
          angular.forEach(matches, function (match) {
            var startPos = match.indexOf('data-field-name="') + 'data-field-name="'.length;
            var endPos = match.indexOf('"', startPos);

            // タグ名を取得
            var tag = match.substring(startPos, endPos);
            tag = tag.replace(/\$/g, '');

            var array_tag = tag.split('*');

            var embeddedFlag = false;
            var array_title = [];
            var title = '';
            angular.forEach(array_tag, function (key) {
              if ($scope.system.array_sample_phrases_kind[key]) {
                // 入力項目
                array_title.push($scope.system.array_sample_phrases_kind[key]);
              } else if ($scope.system.array_sample_phrases_kind_embedded[key]) {
                // 埋込項目
                embeddedFlag = true;
              } else if (
                $scope.fv.docKind == $scope.system.TOPICS_KIND_CURRICULUM &&
                $scope.system.array_sample_phrases_kind_curriculum[key]
              ) {
                // 保育課程
                array_title.push($scope.system.array_sample_phrases_kind_curriculum[key]);
              } else if (
                $scope.fv.docKind == $scope.system.TOPICS_KIND_JOURNAL &&
                $scope.system.array_diary_groups[key]
              ) {
                // クラス日誌
                array_title.push($scope.system.array_diary_groups[key]);
              } else {
                array_title.push(key);
              }
            });

            if ($scope.getSize(array_title) > 0) {
              title = array_title.join(' ');
            } else {
              title = tag;
            }

            tag = tag.replace(/\*/g, '_');

            // 使用中のタグ
            usingTags[tag] = !embeddedFlag;

            // HTMLを変換
            var searchString = match.substring(0, endPos + 1);
            var replaceString =
              searchString +
              (embeddedFlag
                ? ''
                : ' ng-click="startEditPlan( \'' +
                  tag +
                  "', '" +
                  title +
                  "' );\" ng-class=\"{'override' : override['" +
                  tag +
                  "'], 'steady':steady['" +
                  tag +
                  '\']}"');

            var addString = '<div ng-if="isArray(plan.content[\'' + tag + '\'])">';
            addString +=
              '<div ng-if="!content.deleted_flag" ng-repeat="content in plan.content[\'' +
              tag +
              '\']" style="margin-bottom:14px;">';
            addString +=
              '<span ng-if="content.value" ng-class="{\'line-through\' : content.revised || content.cancelled }" style="display:block;">・{{content.value}}</span>';
            addString +=
              '<span style="display:block;margin-bottom:14px;" ng-show="content.revised">・{{ content.revised }}</span>';
            addString += '</div></div>';

            addString += '<div ng-if="!isArray(plan.content[\'' + tag + '\'])">';
            addString +=
              "<span ng-class=\"{'line-through' : plan.content['" +
              tag +
              $scope.revisedSuffix +
              "'] }\">{{plan.content['" +
              tag +
              "']}}</span>";
            addString += "<div>{{plan.content['" + tag + $scope.revisedSuffix + "']}}</div>";
            addString += '</div>';

            addString +=
              '<div class="plan_comment" ng-show="comment.memo[\'' + tag + "']\">{{comment.memo['" + tag + "']}}</div>";
            line = line.replace(match, match.replace(searchString, replaceString) + addString);
          });
        }

        outputHtml.push(line);
      }
    });
  }

  $scope.usingTags = usingTags;

  return outputHtml.join('\n');
}

// 指導案 > 月案 > 個別案作成機能専用のHTML生成ロジック
export function buildHtmlPersonalReport($scope, personal_use) {
  var html = '<tr><td class="left_head"></td>';
  var wrap = '<table class="plan_table plan_table_day excel">__HTML__</table>';
  var outputHtml = '';

  // 生成したHTMLは$compileされるため、項目名が定義されていないタグは描画せず、不正な値によるHTMLインジェクションを防ぐ
  var validPersonalUse = [];
  angular.forEach(personal_use, function (value) {
    // 過去データに空白のキーが入っており、互換性を保つために空文字のキーはundefinedとして扱う
    if (value === '') {
      validPersonalUse.push(value);
    }
    if ($scope.system.array_sample_phrases_kind_personal[value] !== undefined) {
      validPersonalUse.push(value);
    }
  });

  angular.forEach(validPersonalUse, function (value) {
    var title = $scope.system.array_sample_phrases_kind_personal[value];
    html += '<td class="top_head">' + title + '</td>';
  });
  html += '</tr>';
  html += '<tr ng-repeat="member in members">';
  html +=
    '<td class="left_head"><span>{{member.name}}<div ng-show="angular.isDefined( member.monthAge )">（{{member.monthAge}}ヶ月）</div></span></td>';
  angular.forEach(validPersonalUse, function (value) {
    var title = $scope.system.array_sample_phrases_kind_personal[value];
    html += '<td class="input-field" ng-click="startEditMemberPlan( member.id, \'' + value + "', '" + title + '\' )">';
    html += "{{member.plan.content['" + value + "']}}</td>";
  });
  html += '</tr>';

  outputHtml = wrap.replace('__HTML__', html);

  return outputHtml;
}
